import cn from 'classnames';

import { CssUiComponent } from '@webapp/common/components/survey-custom';
import { currentYear } from '@webapp/common/lib/date';

import css from './footer.css';

export const Footer: FC = () => (
    <div className={cn(CssUiComponent.NO_PRINT, css.footer)}>
        <div className={css.container}>
            <div className={css.copyright}>{`2014-${currentYear} права защищены`}</div>
            <div className={css.contacts}>
                <a href='tel:+74951206519'>+7 (495) 120-65-19</a>
                <a className={css.email} href='mailto:info@testograf.ru?subject="сообщение из ЛК"'>
                    info@testograf.ru
                </a>
            </div>
        </div>
    </div>
);
